module.exports = __webpack_public_path__ + "img/hr-level1_dead_mask.e0923d6a.png";